import { DashboardProvider } from './dashboard-provider';

import {
  DashboardControllerProps,
  useDashboardController,
} from './hooks/use-dashboard-controller';
import { DashboardDisplay, DashboardDisplayProps } from './dashboard-display';

export type DashboardProps = DashboardControllerProps & DashboardDisplayProps;

export function Dashboard({
  filter,
  onLoad,
  onRefresh,
  onRequest,
  children,
  ...others
}: DashboardProps) {
  const controller = useDashboardController({
    filter,
    onLoad,
    onRefresh,
    onRequest,
  });

  return (
    <DashboardProvider controller={controller}>
      <DashboardDisplay {...others}>{children}</DashboardDisplay>
    </DashboardProvider>
  );
}
